export default __webpack_public_path__ + "static/media/DRAKE.92c6d4d8.png";